class PlpSeo extends HTMLElement {
  connectedCallback() {
    this.nav = this.querySelector('.plp-seo__nav');
    this.sectionWrapper = this.closest('.shopify-section');
    this.swiper = null;
    if (this.sectionWrapper) this.sectionWrapper.classList.add('plp-seo-section');

    if (this.nav) {
      this.initSwiper();
      this.markActiveLink();
    }
  }

  disconnectedCallback() {
    if (this.swiper) this.swiper.destroy(true, true);
  }

  markActiveLink() {
    // Compare only the pathname so filter query params (e.g. ?filter.v.option.color=beige)
    // don't prevent the correct item from being marked active.
    const currentPath = window.location.pathname;
    let activeItem = null;
    let activeIndex = -1;

    this.querySelectorAll('.plp-seo__link').forEach((link, index) => {
      const linkPath = new URL(link.href, window.location.origin).pathname;

      if (linkPath === currentPath) {
        link.classList.add('plp-seo__link--active');
        link.setAttribute('aria-current', 'page');
        activeItem = link.parentElement; // the <li>
        activeIndex = index;
      }
    });

    if (activeItem) {
      this.scrollActiveIntoView(activeItem, activeIndex);
    }
  }

  scrollActiveIntoView(item, index) {
    if (this.swiper && index > -1) {
      this.swiper.slideTo(index, 0);
      return;
    }

    this.nav.scrollLeft = item.offsetLeft;
  }

  initSwiper() {
    if (typeof Swiper === 'undefined' || !this.nav) return;

    this.swiper = new Swiper(this.nav, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: true,
      watchOverflow: true,
      simulateTouch: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
      },
    });
  }
}

customElements.define('plp-seo', PlpSeo);
